import { jsx as _jsx } from "react/jsx-runtime";
import dynamic from "next/dynamic";
import useTheme from "hooks/useTheme";
import Loading from "components/loading";
var Editor = dynamic(function () {
  return import("components/editor");
}, {
  ssr: false,
  loading: function WhileLoading() {
    return /*#__PURE__*/_jsx(Loading, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("components/editor")];
    },
    modules: ["components/editor"]
  }
});
export default function Home() {
  useTheme();
  return /*#__PURE__*/_jsx(Editor, {});
}